import { panels, page, googletag, gtag } from './Data';
import Menu from './Template/Menu';
import Chat from './Template/Chat';
import { useParams } from "react-router-dom";
import { busqueda } from './Utils/Formatos';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import './Noti.css';
import { NotFound } from './Utils/NotFound';
import Footer from './Template/Footer';
import { Preview } from './Panels';
import { useScrool } from './Utils/useScrool';
import TagManager from 'react-gtm-module';
export default function App() {
  const { pageSLE, panelSLE } = useParams<any>();
  const { id } = busqueda(page, pageSLE);
  const chance = useScrool(pageSLE, panelSLE);
  useEffect(chance, [pageSLE, panelSLE, chance]);
  useEffect(() => {
    if (googletag.tag && googletag.tag !== '') TagManager.initialize({ gtmId: googletag.tag });
    if (googletag.ads && googletag.ads !== '') {
      gtag('config', googletag.ads);
      if (googletag.adsConversion && googletag.adsConversion !== '')
        gtag('event', 'conversion', { 'send_to': googletag.adsConversion });
    }
  }, []);
  useEffect(() => {
    setTimeout(() => {
      if (googletag.tag && googletag.tag !== '') TagManager.dataLayer({ dataLayer: { page: pageSLE ?? "\\" }, dataLayerName: 'page visit' });
      if (googletag.ads && googletag.ads !== '') gtag('event', 'page_visit', { 'page': pageSLE ?? "\\" })
    }, 100);
  }, [pageSLE, panelSLE]);
  return (<>
    <Menu />
    {id === -1 ? <NotFound /> : panels
      .filter(({ pagina, estado }) => id === pagina && estado === 1)
      .sort((a, b) => a.indice - b.indice)
      .map(p => <div key={p.type + p.id} className='w-100 m-0 p-0' id={`panel${p.id}`}>
        <Preview key={p.type + p.id} panel={p} />
      </div>)}
    <Chat />
    <Footer />
    <ToastContainer position='bottom-right' />
  </>);
}
let ainimates: (() => void)[] = [];
export function addAnimate(func: () => void) {
  ainimates.push(func);
}
export function removeAnimate(func: () => void) {
  ainimates = ainimates.filter(i => i !== func);
}
// function ainimated() {
//   ainimates.forEach(func => func());
// }